export function OnboardingModal({
  showOnboarding,
  completeOnboarding
}) {
  if (!showOnboarding) return null;

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-slate-900 to-black rounded-3xl max-w-lg w-full border border-white/10 overflow-hidden max-h-[90vh] overflow-y-auto">
        <div className="p-5 sm:p-8 text-center">
          <img src="/logo-bird.png" alt="Birdie" className="h-16 w-16 sm:h-20 sm:w-20 mx-auto mb-4 rounded-xl" />
          <h2 className="text-2xl sm:text-3xl font-bold mb-2">Welcome to SwingSlot</h2>
          <p className="text-slate-400 mb-6 sm:mb-8 text-sm sm:text-base">Your AI golf coach that helps you improve</p>

          <div className="space-y-4 text-left mb-8">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-emerald-500 text-black font-bold flex items-center justify-center">1</div>
              <div>
                <div className="font-medium">Upload Your Swing</div>
                <div className="text-sm text-slate-400">Any angle, any club, 3-10 seconds</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-emerald-500 text-black font-bold flex items-center justify-center">2</div>
              <div>
                <div className="font-medium">Get AI Analysis</div>
                <div className="text-sm text-slate-400">Birdie identifies your main issue and gives you a drill</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-emerald-500 text-black font-bold flex items-center justify-center">3</div>
              <div>
                <div className="font-medium">Track Your Progress</div>
                <div className="text-sm text-slate-400">Every lesson builds on the last</div>
              </div>
            </div>
          </div>

          <button
            onClick={completeOnboarding}
            className="w-full rounded-xl bg-gradient-to-r from-emerald-500 to-green-500 px-6 py-4 font-bold text-black hover:scale-105 transition"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}
